export const EXPORT_TO_IMAGE_REQUEST = 'EXPORT_TO_IMAGE_REQUEST';
export const EXPORT_TO_IMAGE_SUCCESS = 'EXPORT_TO_IMAGE_SUCCESS';
export const EXPORT_TO_IMAGE_FAILURE = 'EXPORT_TO_IMAGE_FAILURE';
export const EXPORT_TO_PDF_REQUEST = 'EXPORT_TO_PDF_REQUEST';
export const EXPORT_TO_PDF_SUCCESS = 'EXPORT_TO_PDF_SUCCESS';
export const EXPORT_TO_PDF_FAILURE = 'EXPORT_TO_PDF_FAILURE';
export const EXPORT_TO_CSV_REQUEST = 'EXPORT_TO_CSV_REQUEST';
export const EXPORT_TO_CSV_SUCCESS = 'EXPORT_TO_CSV_SUCCESS';
export const EXPORT_TO_CSV_FAILURE = 'EXPORT_TO_CSV_FAILURE';
